import { Form, Modal } from "antd"
import { Store } from "antd/lib/form/interface"
import BugReportForm from "Components/forms/bugReportForm"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { NotificationService, UserService } from "Shared/services"
import { NotificationTypeEnum } from "Shared/services/notification.service"
import { sendBugReport } from "Shared/store/actions/bugReport/bugReport.action"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"

interface BugReportInterface {
    isVisible: boolean
    onCancel: (state: false) => void
}
const BugReportModal: React.FC<BugReportInterface> = ({ isVisible, onCancel }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [formInstance] = Form.useForm()
    const [isLoading, setIsLoading] = useStateIfMounted(false)

    const { email } = UserService.getLoggedInUserProfile()

    const handleSubmit = ({ message }: Store) => {
        setIsLoading(true)
        sendBugReport({ email, message })(dispatch)
            .then(() => {
                NotificationService.send(NotificationTypeEnum.SUCCESS, t("notification:bug_report.title"), t("notification:bug_report.message"))
                handleHide()
            })
            .catch((err) => {
                setIsLoading(false)
                NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:bug_report.title"), t("error:bug_report.message"))
            })
    }

    const handleHide = () => {
        setIsLoading(false)
        formInstance.resetFields()
        onCancel(false)
    }

    return (
        <Modal
            title={t("action:bug_report.create")}
            visible={isVisible}
            maskClosable={false}
            onOk={formInstance.submit}
            onCancel={handleHide}
            okText={t("action:bug_report.submit")}
            cancelText={t("action:cancel")}
            keyboard
            destroyOnClose
            confirmLoading={isLoading}
        >
            <BugReportForm formInstance={formInstance} handleSubmit={handleSubmit} />
        </Modal>
    )
}

export default BugReportModal
